import React from 'react';
import './HomePage.css'

const HomePage = () => {
    return (
        <div className='home-page'>

            <h1>Welcome To The Quiz Session</h1>
            <p>Quizzes are good for revision
                Pre-test quizzes can help pupils revise without even realising they are doing it. And a quiz is a good way for a pupil to identify and take ownership of their knowledge gaps. It's also a great way to help them to plug the gaps to boost their confidence when it comes to formal testing.</p>

        </div>
    );
};

export default HomePage;